import styled from 'styled-components'

const HeadlineWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  align-items: baseline;
  gap: 40px;
  min-width: 880px;
`

const Container = styled.div<{ loading: boolean }>`
  padding-right: 28px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: ${({ loading }) => (loading && '100%')};
`

export { HeadlineWrap, Container }
